import { z } from 'zod/v4';
import {
  TARIFF_PRODUCT_DEFINITION,
  TARIFF_SELECTION_ATTRIBUTE,
  TariffProductGroup,
} from '../../tariff/product-group.interfaces';
import {
  ITicket,
  IWithTicketData,
  TICKET_SCHEMA,
} from '../ticket/ticket.interfaces';
import { ETicketType } from '../ticket/ticket.enums';
import { Brand } from '../../branded-types';
import { ILayoutAssignment } from '../sort-layout-assignment.interfaces';

export type DirectTicketId = Brand<string, 'directTicketId'>;

export const DIRECT_TICKET_SCHEMA: z.ZodType<IDirectTicket> = z.object({
  id: z
    .uuid()
    .transform((s: string) => s as DirectTicketId)
    .optional(),
  type: z.enum(ETicketType),
  ticketData: TICKET_SCHEMA.optional(),
  name: z.string(),
  selectionAttributes: z.array(TARIFF_SELECTION_ATTRIBUTE),
  productDefinitions: z.array(TARIFF_PRODUCT_DEFINITION),
});

export const DIRECT_TICKETS_SCHEMA: z.ZodType<IDirectTicket[]> =
  z.array(DIRECT_TICKET_SCHEMA);

export interface IDirectTicket extends TariffProductGroup, IWithTicketData {
  id?: DirectTicketId;
}

export interface ICmsTicketOverviewItem {
  id: string;
  name: string;
  serviceAreaId: number;
  ticketType: string;
  ticketData?: ITicket;
  sortenExterneReferenzen: string[];
  layoutAssignments?: ILayoutAssignment[];
}
